import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Contract } from './../models/contract.model';


@Injectable({
    providedIn: 'root'
})
export class ContractService {

    contcart: any[];
    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) { }

    getContracts(companyId: number): Promise<Array<Contract>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "contracts/" + companyId)
                .subscribe((response: any) => {
                    this.contcart = response;
                    resolve(response);
                }, reject);
        });
    }

    add(entity: Contract): Promise<Contract> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "contracts/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    upload(entity: FormData): Promise<File> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "upload/contract", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    delete(entity: Contract): Promise<Contract> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "contracts/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updated(entity: Contract): Promise<Contract> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "contracts/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

}
